<template>
  <div>
    <div class="hint" v-if="initShow">
      <img :src="public_path + '/static/images/success_icon@3x.png'" alt="" />
      <span>订单提交成功，请尽快支付</span>
    </div>
    <div class="orderid">订单编号：{{ order_no }}</div>
    <div class="money" v-if="initShow">
      <div class="text">支付金额</div>
      <div class="sum">
        ￥<span>{{ amount }}</span>
      </div>
    </div>
    <div class="way" v-if="initShow">
      <div class="title">选择支付方式</div>
      <div class="channel">
        <div v-if="iswx" class="name">
          <img
            :src="public_path + '/static/images/wechat_icon@3x.png'"
            alt=""
          />
          <span>微信支付</span>
        </div>
        <div v-if="!iswx" class="name">
          <img
            :src="public_path + '/static/images/alipay_icon@3x.png'"
            alt=""
          />
          <span>支付宝支付</span>
        </div>
        <div class="sel-img">
          <img
            :src="public_path + '/static/images/success_icon@3x.png'"
            alt=""
          />
        </div>
      </div>
      <button class="pay-btn" @click="pay">确认支付￥{{ amount }}</button>
    </div>
    <div v-if="showDialog" class="dialog-item">
      <dialog-item :value="massage"></dialog-item>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { payUrl, hostUrl } from "../http/env.js";
import _wx from "../../static/js/chelun-wx-1.1.js";
import URL from "../../static/js/url.js";
import {
  unpaidById,
  pushStudentOrder,
  cancelOrder,
  checkComponentOrderState
} from "@/http/api";
import { baseUrl } from "../http/env.js";
import dialogItem from "./dialog";

export default {
  props: ["payOrder", "openid"],
  data() {
    return {
      serial_number: URL.getQueryString("serial_number"),
      amount: URL.getQueryString("amount"),
      order_no: URL.getQueryString("order_no"),
      showDialog: false,
      public_path: process.env.PUBLICK_PATH,
      paid: false,
      iswx: _wx.isWx,
      initShow: false
    };
  },
  methods: {
    showDia(massage) {
      this.showDialog = true;
      this.massage = massage;
      setTimeout(() => {
        this.showDialog = false;
        this.massage = "";
      }, 1500);
    },
    cancelOrder() {
      let id = this.payOrder.id;
      let channel_uid = this.payOrder.channel_uid;
      let channel_no = this.payOrder.channel_no;
      cancelOrder({
        id: id,
        channel_no: channel_no,
        channel_uid: channel_uid
      }).then(res => {
        if (res.code === 0) {
          this.$router.back(-1);
        }
      });
    },
    checkState() {
      checkComponentOrderState({ order_no: this.order_no }).then(res => {
        if (res.code == 0) {
          if (res.data.pay_state == 0) {
            this.initShow = true;
          } else {
            this.showDia(
              ["未支付", "此订单已支付", "此订单已退款"][res.data.pay_state]
            );
          }
        } else {
          this.showDia(res.msg);
        }
      });
    },
    pay() {
      let channel = _wx.isWx ? "weixin_mp" : "alipay";
      let callbackUrl = `${hostUrl}/agent/compaid?order_no=${this.order_no}`;
      console.log(callbackUrl);
      console.log(222);
      let url = `${payUrl}/api.php?c=order&v=pay2&serial_number=${this.serial_number}&channel=${channel}&openid=${this.openid}&callback_url=${callbackUrl}`;
      console.log(url);
      axios.get(url).then(res => {
        console.log(res);
        if (res.data.code !== 1) {
          this.showDia("订单状态错误");
          return;
        }
        if (_wx.isWx) {
          _wx.pay(res.data.data.order_param, function() {
            window.location.href = res.data.data.order_param.callback_url;
          });
        } else {
          window.location.href = res.data.data.url;
        }
      });
    }
  },
  mounted() {
    if (!this.openid && this.iswx) {
      window.location.href = `${baseUrl}/moments/componentGetOpenId?serial_number=${this.serial_number}&amount=${this.amount}&order_no=${this.order_no}`;
      return false;
    }
    this.checkState();
  },
  components: {
    "dialog-item": dialogItem
  }
};
</script>

<style lang="scss" scoped>
.hint {
  margin-top: 0.7rem;
  text-align: center;
  span {
    font-weight: 600;
  }
  img {
    display: inline-block;
    vertical-align: middle;
    width: 0.47rem;
    height: 0.47rem;
  }
  span {
    font-size: 0.36rem;
    color: #02b389;
    display: inline-block;
    vertical-align: middle;
    margin-left: 0.2rem;
  }
}
.orderid {
  color: rgba(51, 51, 51, 0.4);
  margin-top: 0.16rem;
  text-align: center;
  font-size: 0.26rem;
}
.time {
  margin-top: 0.86rem;
  text-align: center;
  font-size: 0.26rem;
  line-height: 1.8;
  font-weight: 600;
  div:first-child {
    font-weight: 500;
    color: rgba(51, 51, 51, 0.5);
  }
}
.money {
  padding: 0 0.3rem;
  height: 1rem;
  line-height: 1rem;
  border-bottom: 1px solid #ebebeb;
  display: -webkit-flex;
  display: flex;
  .text {
    text-align: left;
    flex: 1;
    color: rgba(51, 51, 51, 0.5);
    font-size: 0.3rem;
  }
  .sum {
    float: right;
    font-size: 0.28rem;
    span {
      font-size: 0.42rem;
    }
  }
}
.way {
  padding: 0 0.3rem;
  .title {
    font-size: 0.3rem;
    line-height: 0.88rem;
    font-weight: 600;
  }
  .channel {
    margin-top: 0.2rem;
    display: -webkit-flex;
    .name {
      flex: 1;
      text-align: left;
      img {
        width: 0.7rem;
        height: 0.7rem;
        display: inline-block;
        vertical-align: middle;
      }
      span {
        display: inline-block;
        font-size: 0.3rem;
        margin-left: 0.31rem;
        vertical-align: middle;
      }
    }
    .sel-img {
      text-align: right;
      flex: 1;
      img {
        width: 0.56rem;
        height: 0.56rem;
        display: inline-block;
        margin-top: 0.08rem;
      }
    }
  }
}
.pay-btn {
  display: block;
  width: 6.9rem;
  height: 0.9rem;
  line-height: 0.9rem;
  background: rgba(2, 179, 137, 1);
  border-radius: 0.45rem;
  color: #fff;
  font-size: 0.32rem;
  margin: 3rem auto auto;
}

.cancel-btn {
  display: block;
  width: 6.9rem;
  height: 0.9rem;
  line-height: 0.9rem;
  border-radius: 0.45rem;
  color: #fff;
  font-size: 0.32rem;
  background: none;
  margin: 0.3rem auto auto;
  color: #333;
  opacity: 0.8;
  border: 1px solid #02b389;
}

.bg {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  .dialog {
    position: absolute;
    width: 4rem;
    height: 2rem;
    padding-top: 0.4rem;
    box-sizing: border-box;
    background: #fff;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    .content {
      font-size: 0.3rem;
      text-align: center;
    }
  }
  .btn {
    border-top: 1px solid #eee;
    display: flex;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 0.8rem;
    button {
      flex: 1;
      background: #fff;
    }
    .sure {
      color: #02b389;
      border-left: 1px solid #eee;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/component.vue